module.exports = __webpack_public_path__ + "static/image/main/m/banner-3@2x.ver2_0_2.jpg?47cc8941";